import { tv } from 'tailwind-variants';

export const chip = tv({
  base: 'font-notoSans flex gap-xs',
  variants: {
    size: {
      sm: 'w-fit h-fit px-2 py-1 text-xs',
      md: 'w-fit h-fit px-3 py-1 text-sm',
      lg: 'w-fit h-fit px-3 py-1 text-md',
    },
    variant: {
      filled:
        'bg-color-brand-primary text-mono-color-white border-hairline border-color-brand-primary',
      negative:
        'bg-mono-color-lighter text-mono-color-black border-hairline border-mono-color-lighter',
      outline:
        'text-mono-color-black border-color-brand-primary border-hairline',
      alterColor:
        'bg-color-transparent text-mono-color-black border-hairline hover:text-mono-color-white',
    },
    color: {
      interdisciplinar: 'border-disciplina-interdisciplinar hover:bg-disciplina-interdisciplinar transition-colors duration-300',
      redacao: 'border-disciplina-redacao hover:bg-disciplina-redacao transition-colors duration-300  ',
      literatura: 'border-disciplina-literatura hover:bg-disciplina-literatura transition-colors duration-300',
      espanhol: 'border-disciplina-espanhol hover:bg-disciplina-espanhol transition-colors duration-300',
      ingles: 'border-disciplina-ingles hover:bg-disciplina-ingles transition-colors duration-300',
      portugues: 'border-disciplina-portugues hover:bg-disciplina-portugues transition-colors duration-300',
      gramatica: 'border-disciplina-portugues hover:bg-disciplina-portugues transition-colors duration-300',
      sociologia: 'border-disciplina-sociologia hover:bg-disciplina-sociologia transition-colors duration-300',
      filosofia: 'border-disciplina-filosofia hover:bg-disciplina-filosofia transition-colors duration-300',
      geografia: 'border-disciplina-geografia hover:bg-disciplina-geografia transition-colors duration-300',
      historia: 'border-disciplina-historia hover:bg-disciplina-historia transition-colors duration-300',
      matematica: 'border-disciplina-matematica hover:bg-disciplina-matematica transition-colors duration-300',
      fisica: 'border-disciplina-fisica hover:bg-disciplina-fisica transition-colors duration-300',
      quimica: 'border-disciplina-quimica hover:bg-disciplina-quimica transition-colors duration-300',
      biologia: 'border-disciplina-biologia hover:bg-disciplina-biologia transition-colors duration-300',
      atualidades: 'border-disciplina-atualidades hover:bg-disciplina-atualidades transition-colors duration-300',
      new: 'border-brand-color-tertiary-pure hover:bg-brand-color-tertiary-pure transition-colors duration-300',
    },
    radius: {
      pill: 'rounded-pill',
      sm: 'rounded-sm',
    },
    active: {
      false: '',
      true: '',
    },
  },
  compoundVariants: [
    {
      variant: 'filled',
      active: false,
      className: 'bg-mono-color-medium text-button-color-primary-disabled',
    },
    {
      variant: 'outline',
      active: false,
      className:
        'text-button-color-secondary-disabled text-button-color-secondary-disabled',
    },
    {
      color: 'interdisciplinar',
      active: true,
      className: 'bg-disciplina-interdisciplinar text-mono-color-white',
    },
    {
      color: 'redacao',
      active: true,
      className: 'bg-disciplina-redacao text-mono-color-white',
    },
    {
      color: 'literatura',
      active: true,
      className: 'bg-disciplina-literatura text-mono-color-white',
    },
    {
      color: 'espanhol',
      active: true,
      className: 'bg-disciplina-espanhol text-mono-color-white',
    },
    {
      color: 'ingles',
      active: true,
      className: 'bg-disciplina-ingles text-mono-color-white',
    },
    {
      color: 'portugues',
      active: true,
      className: 'bg-disciplina-portugues text-mono-color-white',
    },
    {
      color: 'gramatica',
      active: true,
      className: 'bg-disciplina-portugues text-mono-color-white',
    },
    {
      color: 'sociologia',
      active: true,
      className: 'bg-disciplina-sociologia text-mono-color-white',
    },
    {
      color: 'filosofia',
      active: true,
      className: 'bg-disciplina-filosofia text-mono-color-white',
    },
    {
      color: 'geografia',
      active: true,
      className: 'bg-disciplina-geografia text-mono-color-white',
    },
    {
      color: 'historia',
      active: true,
      className: 'bg-disciplina-historia text-mono-color-white',
    },
    {
      color: 'matematica',
      active: true,
      className: 'bg-disciplina-matematica text-mono-color-white',
    },
    {
      color: 'fisica',
      active: true,
      className: 'bg-disciplina-fisica text-mono-color-white',
    },
    {
      color: 'quimica',
      active: true,
      className: 'bg-disciplina-quimica text-mono-color-white',
    },
    {
      color: 'biologia',
      active: true,
      className: 'bg-disciplina-biologia text-mono-color-white',
    },
  ],
});

export const leftIconClasses = tv({
  base: 'cursor-pointer',
  variants: {
    size: {
      sm: 'text-xs',
      md: 'text-sm',
      lg: 'text-md',
    },
    variant: {
      filled: 'fill-current',
      negative: 'fill-current',
      outline: 'fill-current',
      alterColor: 'fill-current',
    },
  },
});

export const rightIconClasses = tv({
  base: 'cursor-pointer',
  variants: {
    size: {
      sm: 'text-xs',
      md: 'text-sm',
      lg: 'text-md',
    },
    variant: {
      filled: 'fill-current',
      negative: 'fill-current',
      outline: 'fill-current',
      alterColor: 'fill-current',
    },
  },
});
